import React from 'react';
import ChartBuilderGeneral from './ChartBuilderGeneral';
import ChartBuilderPrimaryAxisDetails from './ChartBuilderPrimaryAxisDetails';
import ChartBuilderSecondaryAxisDetails from './ChartBuilderSecondaryAxisDetails';
import ChartPresenter from '../ChartPresenter/ChartPresenter';
import Errors from '../Errors/Errors';

export default class ChartBuilderWorkspace extends React.Component {
  constructor(props){
    super(props);
  };

  render(){
    return(
      <div className="panel panel-default">
        <div className="panel-body">
          <Errors errors={this.props.secondaryAxisErrors && this.props.secondaryAxisErrors.header_errors ? this.props.secondaryAxisErrors.header_errors : this.props.errors } />
          {this.renderSteps()}
        </div>
      </div>
    );
  };

  renderSteps() {
    switch (true) {
      case this.props.step === 'general': return <ChartBuilderGeneral {...this.props} />
      case this.props.step === 'primary_axis_details': return <ChartBuilderPrimaryAxisDetails {...this.props} primaryAxisDetail={this.primaryAxisDetail()}/>
      case this.props.step === 'secondary_axis_details': return <ChartBuilderSecondaryAxisDetails {...this.props} axisDataDetails={this.secondaryAxisDetails()} primaryAxisDetail={this.primaryAxisDetail()}/>
      case this.props.step === 'second_y_axis': return <ChartBuilderSecondaryAxisDetails {...this.props} secondaryAxis2={true} primaryAxisDetail={this.primaryAxisDetail()} axisDataDetails={this.secondYAxisDetails()} />
      case this.props.step === 'preview_chart': return <ChartPresenter
        // report_details={this.props.report_details}
        // new_record={this.props.new_record}
        report_details={this.props.preview_report_details}
        date_format={this.props.date_format}
        time_format={this.props.time_format}
      />
    };
  };

  primaryAxisDetail() {
    if (this.props.report_details && this.props.report_details.data_details) {
      return(this.props.report_details.data_details.find(detail => detail.chart_element === this.props.report_details.chart_type.primary_chart_element))
    };
  };

  secondaryAxisDetails(){
    if(this.props.report_details && this.props.report_details.data_details){
      return (this.props.report_details.data_details.filter(detail => detail.chart_element !== this.props.report_details.chart_type.primary_chart_element && detail.chart_element !== 'second-y-axis'));
    };
  };
  secondYAxisDetails(){
    if(this.props.report_details && this.props.report_details.data_details){
      return (this.props.report_details.data_details.filter(detail => detail.chart_element === 'second-y-axis'));
    };
  };

};